// @ts-strict-ignore
export class ChangeMultilineAction {

  private cells: number[][];
  private oldMultilineCounts: number[];
  private newMultilineCount: number;
  private oldCellDataList;
  private restoreCellCoordsStringToOldColSpanMap: Map<string, number>;

  constructor(cells: number[][], oldMultilineCounts: number[], newMultilineCount: number, oldCellDataList,
    restoreCellCoordsStringToOldColSpanMap: Map<string, number>) {
    this.cells = cells;
    this.oldMultilineCounts = oldMultilineCounts;
    this.newMultilineCount = newMultilineCount;
    this.oldCellDataList = oldCellDataList;
    this.restoreCellCoordsStringToOldColSpanMap = restoreCellCoordsStringToOldColSpanMap;
  }

  public undo(instance, undoneCallback) {
    // instance is of type handsontable, which gets applied by handsontable to done actions (action part of undostack)
    for (let i: number = this.cells.length - 1; i >= 0; i--) {
      instance.labelEditorTabComponent.changeMultilineCount([this.cells[i]], this.oldMultilineCounts[i],
        this.restoreCellCoordsStringToOldColSpanMap);
    }
    instance.setDataAtCell(this.oldCellDataList);
    // undo operation completed, trigger callback:
    // this is original callback style, now improved by doing callback immediately
    // instance.addHookOnce('afterRender', undoneCallback);
    // instance.render();
    if (undoneCallback) {
      undoneCallback();
    }
  }

  public redo(instance, redoneCallback) {
    instance.labelEditorTabComponent.changeMultilineCount(this.cells, this.newMultilineCount);
    // redo operation completed, trigger callback:
    // this is original callback style, now improved by doing callback immediately
    // instance.addHookOnce('afterRender', redoneCallback);
    // instance.render();
    if (redoneCallback) {
      redoneCallback();
    }
  }
}
